module.exports = function HelpCenterDirective(helpCenterService, $sce, BwsBotService) {
    return {
        restrict: 'E',
        template: require('./help-center-template.html'),
        scope: {},
        link(scope, element) {
            scope.searchTerm = "";
            scope.currentPageNumber = 1;
            scope.searchResult = {};
            scope.searchedArticles = [];
            scope.totalNumberOfArticles = 0;
            scope.totalNumberOfPages = 0;
            scope.shouldShowLandingPageTemplate = true;
            scope.shouldShowQuickAnswerSection = true;
            scope.shouldShowPopularArticlesSection = true;
            scope.shouldShowArticle = false;
            scope.selectedArticle = {};
            scope.searchText = "";
            scope.getSearchResult = function (searchText) {
                scope.searchTerm = searchText;
                if (!scope.shouldShowSearchResultTemplate) {
                    scope.showSearchTemplate();
                }
            };

            scope.checkEnterKey = function (event, searchText) {
                if (event.keyCode === 13) {
                    scope.getSearchResult(searchText);
                }
            };

            scope.showArticle = function (article) {
                hideAllTemplates();
                scope.selectedArticle = article;
                scope.shouldShowArticle = true;
            }
            scope.showSearchTemplate = function () {
                hideAllTemplates();
                scope.shouldShowSearchResultTemplate = true;
            };

            scope.showLandingPageTemplate = function () {
                hideAllTemplates();
                scope.shouldShowLandingPageTemplate = true;
                scope.shouldShowQuickAnswerSection = true;
            };

            function hideAllTemplates() {
                scope.shouldShowSearchResultTemplate = false;
                scope.shouldShowLandingPageTemplate = false;
                scope.shouldShowSectionArticles = false;
                scope.shouldShowArticle = false;
                scope.shouldShowQuickAnswerSection = false;
                scope.shouldShowPopularArticlesSection = false;

            }


            scope.categories = []; // Declare categories on the scope
            scope.sections = [];
            scope.articles = [];
            scope.shouldShowSectionArticles = false;
            scope.selectedCategoryId = null;

            // Fetch categories on initialization
            helpCenterService.getCategories()
                .then(function (categories) {
                    scope.categories = categories;
                    // Ensure scope updates correctly in AngularJS
                    scope.$evalAsync();
                })
                .catch(function (error) {
                    console.error("Error fetching categories:", error);
                });

            // Fetch sections based on category ID
            scope.showSectionsArticles = function (categoryId) {
                hideAllTemplates();
                scope.shouldShowSectionArticles = true;
                scope.selectedCategoryId = categoryId;
                scope.shouldShowQuickAnswerSection = true;
            };
            scope.showQuickAnswerAndPopularArticlesSection = function () {
                scope.shouldShowPopularArticlesSection = true;
                scope.shouldShowQuickAnswerSection = true;
            };
            scope.hideQuickAnswerAndPopularArticlesSection = function (categoryId) {
                scope.shouldShowPopularArticlesSection = false;
                scope.shouldShowQuickAnswerSection = false;
            };

            hideAllTemplates();
            scope.shouldShowLandingPageTemplate = true;
            scope.shouldShowQuickAnswerSection = true;
            scope.shouldShowPopularArticlesSection = true;

            // Add this function to open the chat
            scope.openChatBot = function () {
                BwsBotService.chatWithBot();
            };



        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/help-center/help-center-directive.js
 **/